
import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';

interface User {
  id: string;
  email: string;
  name: string | null;
  access_level: 'usuario' | 'admin';
}

type DatabaseUser = {
  id: string;
  email: string;
  name: string | null;
  access_level: string;
  active: boolean;
  password: string;
  created_at: string;
  updated_at: string;
}

export function useSimpleAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const validateAccessLevel = (level: string): 'usuario' | 'admin' => {
    return level === 'admin' ? 'admin' : 'usuario';
  };

  const login = async (email: string, password: string) => {
    try {
      const { data, error } = await supabase
        .from('cat_users')
        .select('*')
        .eq('email', email)
        .eq('password', password)
        .eq('active', true)
        .single();

      if (error || !data) {
        throw new Error('Credenciais inválidas');
      }

      const dbUser = data as DatabaseUser;
      const user: User = {
        id: dbUser.id,
        email: dbUser.email,
        name: dbUser.name,
        access_level: validateAccessLevel(dbUser.access_level)
      };

      setUser(user);
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('isAuthenticated', 'true');
      return true;
    } catch (error) {
      console.error('Erro no login:', error);
      toast.error('Credenciais inválidas');
      return false;
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('isAuthenticated');
  };

  const isAuthenticated = () => {
    return localStorage.getItem('isAuthenticated') === 'true';
  };

  return {
    user,
    loading,
    login,
    logout,
    isAuthenticated
  };
}
